import { useNavigate } from 'react-router-dom';
import './tabs.css';

const Tab = ({ label, value, activeTab, setActiveTab, disabled, icon }) => {
    const isActive = activeTab === value;

    const handleClick = () => {
        setActiveTab(value);
    };
    return (
        <div className='button-wrapper'>
            <button disabled={disabled} onClick={handleClick} className={`tab ${isActive ? 'active' : ''}`}>
                {/* icon is optional so existing callers (billing tabs) that
                    don't pass one render exactly as before */}
                {icon && <span className='tabIcon'>{icon}</span>}
                {label}
            </button>
            {disabled && <span className='coming-soon-tag'>Coming Soon</span>}
        </div>
    );
};

export default Tab;
